import React from "react";
import { css } from "@emotion/css";

export const EditorToolbar: React.FC<{ actions?: React.ReactNode }> = ({ children, actions }) => (
  <header className={styles.bar}>
    {children}
    <div className={styles.actions}>{actions}</div>
  </header>
);

const styles = {
  bar: css`
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    margin-bottom: 8px;
    background: #ebebeb;
  `,
  actions: css`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  `,
};
